import toggleCallbacks from 'tap-toggle-pairs/callbacks';
import setupTogglePair from 'tap-toggle-pairs/tap-toggle-pairs';

module.exports.initPayoutPaidButtons = function() {
    setupTogglePair('mark-payout-unpaid', 'mark-payout-paid', 'tap_payout_api_pub_ai_payout_paid_stateful', toggleCallbacks.payoutPaidCallback, "DELETE", "PUT");
};

module.exports.initCommissionApprovalButtons = function() {
    setupTogglePair('disapprove-commission', 'approve-commission', 'tap_tracking_api_commission_approved_stateful', toggleCallbacks.approveCommissionCallback, "DELETE", "PUT");
};

module.exports.initAffiliateApprovalButtons = function() {
    setupTogglePair('disapprove-publisher', 'approve-publisher', 'tap_publishing_frontend_ai_affiliate_approveaffiliateforallprograms', toggleCallbacks.publisherApprovalCallback, "DELETE", "PUT");
};
